<template>
  <div class="table-periods mt-3">
    <offer-period-form
      v-for="(offerPeriod, index) in offerPeriods"
      :index="index"
      :offerPeriod="offerPeriod"
      :timeCodesOptions="timeCodesOptions"
      :offerPeriodsCount="offerPeriodsCount"
      :key="offerPeriod.id"
      :disabledDate = "disabledDate"
      @updatePeriod="updatePeriod"
      @removePeriod="removePeriod"
      />

    <div class="clearfix">
      <button class="btn m-t-10 float-right" @click="addOfferPeriod">
        <i class="fa fa-plus m-r-5" />
        {{ $t("OfferPeriodsForm.add_new_period") }}
      </button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters, mapActions } from 'vuex'
  import OfferPeriodForm from '@/components/offers/OfferPeriodForm'

  export default {
    name: 'OfferPeriodsForm',
    props: ['offerPeriods', 'maxDate', 'disabledDate', 'numberOfOfferPeriods'],
    components: { OfferPeriodForm },
    data() {
      return {
        offerPeriodsCount: this.numberOfOfferPeriods !== undefined ? this.numberOfOfferPeriods : 1
      };
    },
    computed: {
      ...mapGetters({
        timeCodesOptions: 'users/timeCodes'
      })
    },
    methods: {
      ...mapActions({
        addPeriod: 'offers/addPeriod'
      }),

      addOfferPeriod() {
        this.offerPeriodsCount++
        this.addPeriod(moment(this.maxDate).add(1, 'day'))
      },

      removePeriod(index) {
        this.offerPeriodsCount--
        this.$emit('removeOfferPeriod', index)
      },

      updatePeriod(index, data) {
        this.$emit('updateOfferPeriod', index, data);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/offers/OfferPeriodsForm.vue